import { defineComponent, ref, openBlock, createBlock, unref, withCtx, createElementBlock, Fragment, renderList, toDisplayString } from "vue";
import { CdrSelect } from "@rei/cedar";
import { ESortCategory } from "../../types/pinia/ProductReviewsModel.mjs";
const _hoisted_1 = ["value"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsDropdownSort",
  emits: ["metricsClick", "productReviewsSort"],
  setup(__props, {
    emit: __emit
  }) {
    const data = ref([{
      name: "Most Relevant",
      value: ESortCategory.RELEVANCY
    }, {
      name: "Most Helpful",
      value: ESortCategory.MOST_HELPFUL
    }, {
      name: "Most Recent",
      value: ESortCategory.MOST_RECENT
    }, {
      name: "Highest to Lowest Rating",
      value: ESortCategory.HIGHEST_RATING
    }, {
      name: "Lowest to Highest Rating",
      value: ESortCategory.LOWEST_RATING
    }]);
    const emit = __emit;
    async function onDropdownChange(e) {
      const target = e.target;
      const selectedOption = target.options[target.selectedIndex];
      const text = selectedOption.text.toLowerCase();
      const payload = {
        sortCategory: target.value
      };
      emit("productReviewsSort", payload);
      emit("metricsClick", {
        linkName: `reviews_sort_${text}`
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(CdrSelect), {
        modelValue: unref(ESortCategory).RELEVANCY,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => unref(ESortCategory).RELEVANCY = $event),
        background: "primary",
        label: "Sort by",
        onChange: onDropdownChange
      }, {
        default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(data.value, ({
          name,
          value
        }) => {
          return openBlock(), createElementBlock("option", {
            key: value,
            value
          }, toDisplayString(name), 9, _hoisted_1);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsDropdownSort.mjs.map
